'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseTooltip=require('../../../../dist-es6/client/directives/tooltips/baseTooltip');let

BaseControllerBackedTooltip=function(_BaseTooltip){_inherits(BaseControllerBackedTooltip,_BaseTooltip);function BaseControllerBackedTooltip(){_classCallCheck(this,BaseControllerBackedTooltip);return _possibleConstructorReturn(this,_BaseTooltip.apply(this,arguments))}BaseControllerBackedTooltip.prototype.
factory=function factory(){var _this2=this;
return Object.assign({},_BaseTooltip.prototype.factory.call(this),{
controller:this.controller,
controllerAs:'controller',
bindToController:!0,
link:{
pre:function(scope){
if(_.exists(_this2.bindings)){

for(const binding of _this2.bindings){
scope.controller[binding]=scope.bindings[binding];
}
}else{

scope.controller=scope.bindings;
}
}}});


};return BaseControllerBackedTooltip}(BaseTooltip);


module.exports=BaseControllerBackedTooltip;
//# sourceMappingURL=baseControllerBackedTooltip.js.map
